import React from "react"
import styled from "@emotion/styled"

import sidebarHero from "../../../images/sidebar-torneo.jpg"

const SignUpFoxBox = styled.div`
  background-image: url(${sidebarHero});
  background-repeat: no-repeat;
  background-size: contain;
  width: 30vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: black;
  @media (max-width: 850px) {
    display: none;
  }
  @media (min-width: 1990px) {
    background-size: cover;
  }
`

const SignUpFox = () => (
  <>
    <SignUpFoxBox>

    </SignUpFoxBox>
  </>
)

export default SignUpFox
